import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Preview from 'app/preview';
import { addAccessDeniedInterceptor } from './services/AxiosHelper';

import 'styles/app.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-hawksearch/dist/esm/react-hawksearch.css';

import { Router, Route, Switch } from 'react-router-dom';
import AccessDenied from 'components/access-denied/AccessDenied';
import PageNotFound from 'components/not-found/PageNotFound';
import AppInitializer from 'components/AppInitializer';
import browserHistory from 'utils/history';
import AppConfiguration from 'AppConfiguration';
import './widgets/hawk-searchbox';
import './widgets/hawk-results-page';

if (!(window as any).browserHistory) {
	(window as any).browserHistory = browserHistory;
}

addAccessDeniedInterceptor(browserHistory);

function App({ id }) {
	const elem = document.getElementById(id);
	let clientGuid = '';
	let siteDirectory = '';
	let indexName = '';
	if (elem) {
		clientGuid = elem.getAttribute('data-client-guid') || clientGuid;
		siteDirectory = elem.getAttribute('data-site-directory') || siteDirectory;
		indexName = elem.getAttribute('data-index-name') || indexName;
		AppConfiguration.setAppConfiguration({
			siteDirectory,
			clientGUID: clientGuid,
			indexName,
			trackingAPI: elem.getAttribute('data-tracking-api') || '',
			baseAPI: elem.getAttribute('data-base-api') || '',
			searchAPI: elem.getAttribute('data-search-api') || '',
			autocompleteAPI: elem.getAttribute('data-autocomplete-api') || '',
		});
	}
	return (
		<AppInitializer>
			<Router history={browserHistory}>
				<Switch>
					{/* <Route path="/" exact component={AccessDenied} />
					<Route path="/access-denied/" exact component={AccessDenied} />
					<Route path="/:clientName" component={Preview} />
					<Route component={PageNotFound} /> */}
					<Route
						path=""
						component={props => (
							<Preview
								{...props}
								clientGuid={clientGuid}
								siteDirectory={siteDirectory}
								indexName={indexName}
							/>
						)}
					/>
				</Switch>
			</Router>
		</AppInitializer>
	);
}

// if (document.getElementById('react-app')) {
// 	ReactDOM.render(<App id={'react-app'} />, document.getElementById('react-app'));
// }
